import { RichText, HeroMedia, SEO, SEOProps } from '@islandsstofa/react'

export default {
  PrismicCapitalBodyRichtext: {
    component: RichText,
    dataToProps(data: any) {
      return {
        html: data.primary.content.html
      }
    }
  },
  PrismicCapitalBodySeo: {
    component: SEO,
    dataToProps: (data: any): SEOProps => ({
      title: data.primary.override_title,
      description: data.primary.override_description,
      image: data.primary.override_image,
      keywords: data.primary.override_keywords
    })
  },
  PrismicCapitalBodyHeroMedia: {
    component: HeroMedia,
    dataToProps(data: any) {
      const {
        primary: {
          caption,
          single_image: singleImage,
          video,
          firstonpage: firstOnPage
        },
        items: gallery
      } = data

      return {
        caption,
        singleImage,
        video,
        gallery,
        firstOnPage
      }
    }
  }
}
